import Vue from 'vue';
import App from './App';
import API from './api/index';
import store from './store/index';
import { storeKey } from './constants/common';

//wx
import {
  wechatInit,
  wechatUserInfoAuth,
  wxCloseWindow,
  initWxShare
} from './sdk/weixin';

//fibo
import { fiboInit } from '@/sdk/fibo';
import checkWeChatNav from './utils/checkWeChatNav';
import isIOS from './utils/isIOS';
import isWeChat from './utils/isWeChat';

let mainVue = null;
let wechat = null;

let vueInitedEvent = new Event('vue-inited');
let roadClearEvent = new Event('road-clear');
let roadCleared = false;
let pingSuccess = false;

export const init = async () => {
  if (isWeChat()) {
    wechat = wechatInit();
    initWxShare();
    // 后端检测
    if (!localStorage.getItem(storeKey) && wechat.getQuery('code')) {
      roadCleared = true;
      pingSuccess = true;
    } else {
      roadClear();
    }
    //二次进入
    if (JSON.parse(localStorage.getItem(storeKey))) {
      // 获取信息
      let { userInfo } = JSON.parse(localStorage.getItem(storeKey));
      initVue();
      handleRoadClear(roadClearEvent, () => {
        handleVueInited(() => {
          mainVue.$bus.emit('ping-finish', true);
        });
        // 获取活动状态
        pingSuccess && handleEventState(userInfo.accessToken);
      });
    } else if (wechat.getQuery('code')) {
      let code = wechat.getQuery('code');
      // 登录
      handleRoadClear(roadClearEvent, () => {
        // 获取活动状态
        pingSuccess && handleEventState(false, code);
      });
      // 修复ios微信白条
      if (isIOS()) {
        checkWeChatNav(750 / 1000, 'has-wechat-nav', h => {
          initVue();
          mainVue.$bus.emit('nav-resize', {
            h: h
          });
          mainVue.$bus.emit('ping-finish', true);
        });
      } else {
        initVue();
        mainVue.$bus.emit('ping-finish', true);
      }
    } else {
      initVue();
      handleRoadClear(roadClearEvent, () => {
        handleVueInited(() => {
          mainVue.$bus.emit('ping-finish', !pingSuccess);
        });
        pingSuccess && (handleEventState(false,false,()=>{
          initAuthPage();
          wechatUserInfoAuth();
        }));
      });
    }
  } else {
    // debug
    initVue();
    fiboInit();
  }
};

// ping接口处理
function handleRoadClear(event, cb) {
  if (!roadCleared) {
    window.addEventListener(event.type, cb);
  } else {
    cb();
  }
}
// ping接口检测
async function roadClear() {
  let res = await API.getH5Ping().catch(e => {
    console.debug('road clear:', e);
    handleVueInited(() => {
      // 走活动繁忙页
      mainVue.$bus.emit('event-state', -1);
      mainVue.$bus.emit('login-fail');
      mainVue.$bus.emit('limit-state', e.limited ? 503 : 1);
    });
  });

  if (res) {
    pingSuccess = true;
  }
  roadCleared = true;
  window.dispatchEvent(roadClearEvent);
}

function initVue() {
  mainVue = new Vue({
    store,
    render: h => h(App)
  }).$mount('#app');
  window.dispatchEvent(vueInitedEvent);
}

function initAuthPage() {
  const authPage = document.querySelector('.auth-page');
  window._refresh = () => {
    location.reload(true);
  };

  setTimeout(() => {
    if (
      JSON.parse(localStorage.getItem(storeKey))
    ) {
      // 如果已授权则移除重新授权提示
      document.body.removeChild(authPage);
      window._refresh = null;
    } else {
      // 弹出授权提示
      authPage.style.display = 'block';

      let apWrapper = document.querySelector('.auth-page .auth-page-wrapper');
      apWrapper.style.transition = `all 0.3s ease-in`;
      setTimeout(() => {
        apWrapper.style.opacity = 1;
      });
    }
  }, 2000);
}

// pc端限制
export const initTipsPage = () => {
  const authPage = document.querySelector('.tips-page');

  authPage.style.display = 'block';

  let apWrapper = document.querySelector('.tips-page .tips-page-wrapper');
  apWrapper.style.transition = `all 0.3s ease-in`;

  apWrapper.style.opacity = 1;
};

// vue初始化状态处理
function handleVueInited(cb) {
  if (!mainVue) {
    window.addEventListener(vueInitedEvent.type, cb);
  } else {
    cb();
  }
}

// 通过后台授权
async function login(code, mock = false) {
  let res = await API.getH5Login({
    mock: mock,
    code: code
  }).catch(e => {
    console.warn('error in API.getH5Login().catch:', e);
    if (e.data.error_code === -3001) {
      initAuthPage();
      wechatUserInfoAuth();
      return;
    }
    handleVueInited(() => {
      // 活动繁忙页
      mainVue.$bus.emit('login-fail');
      mainVue.$bus.emit('limit-state', e.limited ? 503 : 1);
    });
  });

  if (res) {
    API.setToken(res.result.accessToken);

    fiboInitUserinfo(res.result);
    handleVueInited(() => {
      store.commit('LOGIN', res.result);
      mainVue.$bus.emit('login-finish', {
        cardType: res.result.cardType,
        received: res.result.received
      });
    });
    console.debug('login res:', res);
  }
}

// 获取用户信息
async function getInfo(token) {
  API.setToken(token);
  let res = await API.getH5Info().catch(e => {
    console.warn('error in API.getH5Info().catch:', e);

    if (e.data.error_code === -1005) {
      localStorage.removeItem(storeKey);
      // 重新授权
      initAuthPage();
      wechatUserInfoAuth();
      return;
    }

    handleVueInited(() => {
      // 活动繁忙页
      mainVue.$bus.emit('login-fail');
      mainVue.$bus.emit('limit-state', e.limited ? 503 : 1);
    });
  });

  if (res) {
    console.debug('getInfo res:', res);
    try {
      let { userInfoFibo } = JSON.parse(localStorage.getItem(storeKey));

      fiboInitUserinfo(userInfoFibo);
    } catch (e) {
      console.debug('get userInfoFibo from localStorage fail:', e);
      fiboInitUserinfo();
    }

    handleVueInited(() => {
      store.commit('GET_INFO', res.result);
      mainVue.$bus.emit('login-finish', {
        cardType: res.result.cardType,
        received: res.result.received
      });
    });
    // 清除后台数据，上线修改
    // if (/clear=110/.test(location.search)) {
    //   await API.getUtilsClearOne().catch(e => {
    //     console.debug('清除个人数据失败', e);
    //   });
    //   localStorage.removeItem(storeKey);
    //   wxCloseWindow();
    //   return;
    // }
  }
}

// 获取活动状态并初始化相应状态的页面
async function handleEventState(token = false, code = false,authFn=false) {
  let res = await API.getH5Status().catch(e => {
    console.warn('error in API.getH5Status().catch:', e);

    handleVueInited(() => {
      // 走活动繁忙页
      mainVue.$bus.emit('event-state', -1);
      mainVue.$bus.emit('login-fail');
      mainVue.$bus.emit('limit-state', e.limited ? 503 : 1);
    });
  });

  if (res) {
    let now = res.result.now,
      start = res.result.start,
      end = res.result.end;

    let state = now > end ? 4 : now < start ? 3 : 1;

    console.log('state:', state);
    // 走活动状态页
    handleVueInited(() => {
      mainVue.$bus.emit('event-state', state);
      if (state === 3 || state === 4) {
        // 不在活动期间不请求登录
        mainVue.$bus.emit('login-fail');
      }
    });

    if(authFn){
      if(state===1){
        authFn();
      }else if(state===3||state===4){
        handleVueInited(() => {
          // 显示页面弹窗
          mainVue.$bus.emit('ping-finish', true);
        });
      }
    }else{
      if (state === 1) {
        if (token) {
          getInfo(token);
        }
        if (code) {
          login(code);
        }
      }
    }
  }
}

function fiboInitUserinfo(userInfoFibo = {}) {
  try {
    if (!userInfoFibo) {
      fiboInit();
      return;
    }
    let {
      openid,
      nickname,
      sex,
      language,
      city,
      province,
      country,
      headimgurl,
      privilege
    } = userInfoFibo;

    fiboInit({
      openid: openid,
      nickname: nickname,
      sex: sex,
      language: language,
      city: city,
      province: province,
      country: country,
      headimgurl: headimgurl,
      privilege: privilege
    });
  } catch (e) {
    console.debug('fiboInitUserinfo error:', e);
    fiboInit();
  }
}
